import React from 'react'
import '@loyal_template/placeholder.css'

const WrapperSliderPlaceholder = () => (
  <div className='container-slider container-fluid  py-2'>
    <div className=' container pos-relative radius px-0'>
      <div className='csslider infinity' />
    </div>
  </div>
)

export default WrapperSliderPlaceholder



// WEBPACK FOOTER //
// ./src/features/Slider/wrapperSlider/WrapperSliderPlaceholder.js